import {
  FormDataPost,
  FormDataPostLocal,
  Get,
  Post,
  getAPIUrl,
} from "./apiMethod";
import { Authendpoint, Globalendpoints } from "./global";

export const userSignup = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.Signup, param);
  return Post(url, data, false);
};
export const userLoginWithPassword = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.LoginMobile, param);
  return Post(url, data, false);
};
export const userRegister = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.Register, param);
  return FormDataPost(url, data);
};
export const userLogin = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.Login, param);
  return FormDataPost(url, data, false);
};
export const OtpVerify = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.OtpVerify, param);
  return FormDataPost(url, data, false);
};
export const registerUserOtp_verify = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.registerUserOtp_verify, param);
  return FormDataPost(url, data, false);
};
export const resendOtp = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.resendOtp, param);
  return FormDataPost(url, data);
};
export const getProfile = (param = "") => {
  const url = getAPIUrl(Globalendpoints.profile, param);
  return Get(url);
};
export const updateProfile = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updateProfile, param);
  return FormDataPostLocal(url, data);
};
export const getBankDetail = (param = "") => {
  const url = getAPIUrl(Globalendpoints.bankDetail, param);
  return Get(url);
};

export const getallTickets = (data,param = "") => {
  const url = getAPIUrl(Globalendpoints.getallTickets, param);
  return FormDataPostLocal(url, data);
};
export const buyTickets = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.buyTickets, param);
  return FormDataPostLocal(url, data);
};
export const AddFundReq = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.AddFundReq, param);
  return FormDataPostLocal(url, data);
};
// export const walletBal = (param = "") => {
//   const url = getAPIUrl(Globalendpoints.walletBalance, param);
//   return Get(url);
// };
export const AllTransactions = (param = "") => {
  const url = getAPIUrl(Globalendpoints.allTransaction, param);
  return Get(url);
};
export const getResultDetails = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.getResultDetails, param);
  return FormDataPostLocal(url, data);
};
export const GetFundReq = (param = "") => {
  const url = getAPIUrl(Globalendpoints.fundReq, param);
  return Get(url);
};
export const getmyTickets = (data,param = "") => {
  const url = getAPIUrl(Globalendpoints.getmyTickets, param);
  return FormDataPostLocal(url,data);
};
export const getWithdrawDetails = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getWithdrawDetails, param);
  return Get(url);
};
export const AddWithdrawReq = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.AddWithdraReq, param);
  return FormDataPostLocal(url, data);
};
export const getWithdrawreq = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.withdrawReq, param);
  return FormDataPostLocal(url, data);
};

// -----------------------------------------------

export const ForgotPassword = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.forgotPassword, param);
  return Post(url, data, false);
};
export const ForgotPasswordOtpVerify = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.forgotPasswordOtpVerify, param);
  return Post(url, data, false);
};
export const ResetPassword = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.resetPassword, param);
  return Post(url, data, false);
};

export const MakeBet = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.betting, param);
  return Post(url, data);
};
export const MyBets = (param = "") => {
  const url = getAPIUrl(Globalendpoints.myBets, param);
  return Get(url);
};

export const getWinningHistory = (param = "") => {
  const url = getAPIUrl(Globalendpoints.winningHistory, param);
  return Get(url);
};
export const getBetHistory = (param = "") => {
  const url = getAPIUrl(Globalendpoints.betHistory, param);
  return Get(url);
};
